import { Component, Injector, ChangeDetectionStrategy } from '@angular/core';
import { ObjectManagerComponentBase } from '../../../core/component/object-manager/object-manager.base';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { ColumnDefinitionService } from '../../../rent/service/data/column-definition.service';
import { StandardCommandHandlerResolver } from '../../../core/service/command/standard-command-handler-resolver.service';
import { PriceList } from '../../model/pricelist';
import { PriceListService } from '../../service/data/pricelist.service';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { map } from 'rxjs';
import { ImportPriceListFormComponent } from '../import-pricelist-form/import-pricelist-form.component';

@Component({
    selector: 'app-pricelist-manager',
    templateUrl: 'pricelist-manager.component.html',
    styleUrls: ['pricelist-manager.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PriceListManagerComponent extends ObjectManagerComponentBase<PriceList> {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    dataService: PriceListService,
    dispatcher: CommandDispatcher,
    handlerResolver: StandardCommandHandlerResolver,
    messageService: MessageService,
    navigationService: NavigationService,
    private actionService: ActionWindowService,
    private injector: Injector
  ) {
    super(dataService, messageService, navigationService, dispatcher, handlerResolver);

    this.columnDefinition = columnDefinitionService.create('PriceList');

    this.title = 'PRICELIST.PRICELISTS';
    this.preferencesKey = 'common.pricelist-manager.list';
  }

  importSabo() {
    this.actionService
      .open(ImportPriceListFormComponent, this.injector, null, null, false)
      .pipe(
        map(result => {
          this.navigation.reloadCurrentRoute();
        })
      )
      .subscribe();
  }
}
